export const API_CONFIG = {
  BASE_URL: "https://5d9wvre5lg.execute-api.us-east-1.amazonaws.com/dev",
  TIMEOUT: 30000, // 30 seconds
  ENDPOINTS: {
    SEARCH_HEADERS: "/amzl/v1/search-results",
    GET_LINES: "/amzl/v1/get-line-details",
    GET_SUBINVENTORY_LOV: "/amzl/v1/get-subinventory-lov",
    GET_LOCATOR_LOV: "/amzl/v1/get-locator-lov",
    GET_VALIDATED_SN_ITEM: "/amzl/v1/get-validated-sn-item",
    GET_SESSION_DTLS: "/amzl/v1/get-session-dtls",
    GET_RAD_SITES: "/amzl/v1/get-rad-sites",
    GET_SUPP_ITEM_LIST: "/amzl/v1/get-supp-item-list",
    GET_REPLACEMENT_ORDER_DTLS: "/amzl/v1/get-replacement-order-dtls",
    VALIDATE_SERIAL_NUMBER: "/amzl/v1/validate-sn",
    UPDATE_TO_ORG_DETAILS: "/amzl/v1/update-to-org-details",
    UPSERT_LINE_DETAILS: "/amzl/v1/upsert-line-details",
    STAGE_SERIAL_NUMBERS: "/amzl/v1/stage-serial-numbers",
    SUBMIT_REQUEST: "/amzl/v1/submit-request",
    GET_PALLET_DETAILS: "/amzl/v1/get-pallet-details",
    GET_CAGE_DETAILS: "/amzl/v1/get-cage-details",
    GET_TOTE_DETAILS: "/amzl/v1/get-tote-details",
    CREATE_LOCATOR: "/amzl/v1/create-locator",
    GET_EXCEPTION_ITEM_LIST: "/amzl/v1/get-exception-item-list",
    IS_REPAIR_ELIGIBLE: "/amzl/v1/is-repair-eligible",
    AUTHORIZE_PROBLEM_SOLVER: "/amzl/v1/authorize-problem-solver",
    GET_FROM_SITE_WHID: "/amzl/v1/get-from-site-whid",
  },
};
